import React from 'react';

import { SpendTypeEnum } from 'components/Classification';
import { SPEND_LABELS } from 'components/Classification/ClassificationTable/utils';
import {
  Wrapper,
  Divider,
  ActionItem,
  Title,
  RightSection,
  StyledLink,
} from './Subheader.styles';
import {
  ApButtonOrange,
  ApButtonSecondary,
  ApSimpleDropdown,
  IOption,
} from '@alixpartners/ui-components';

interface IProps {
  onSave(): void;
  dateOptions: IOption[];
  selectedDate: IOption;
  onDateChange(option: IOption | IOption[]): void;
  spendType: SpendTypeEnum;
  isSaveActive: boolean;
  backUrl: string;
  title: string;
}

export const Subheader: React.FC<IProps> = ({
  onSave,
  dateOptions,
  selectedDate,
  onDateChange,
  spendType,
  isSaveActive,
  backUrl,
  title,
}) => {
  return (
    <Wrapper>
      <ActionItem>
        <StyledLink to={backUrl}>
          <ApButtonSecondary iconName="baseline_arrow_back">
            Back
          </ApButtonSecondary>
        </StyledLink>
      </ActionItem>
      <Divider />
      <Title>
        {SPEND_LABELS[spendType]} spend {title} allocation
      </Title>
      <RightSection>
        <ApSimpleDropdown
          onChange={onDateChange}
          options={dateOptions}
          selected={selectedDate}
        />
        <Divider />
        <ActionItem>
          <ApButtonOrange onClick={onSave} disabled={!isSaveActive}>
            Save allocation
          </ApButtonOrange>
        </ActionItem>
      </RightSection>
    </Wrapper>
  );
};
